import { g as getAssetPath } from './index-0859a102.js';

function getAssetRelativePath(relativePath, basePath) {
    return basePath ? `${basePath}/${relativePath}` : getAssetPath(relativePath);
}

export { getAssetRelativePath as g };

//# sourceMappingURL=relativepath-helper-948108b1.js.map